export default __webpack_public_path__ + "static/media/car-2.38d94483.gif";